import { render, staticRenderFns } from "./footer-component.vue?vue&type=template&id=145c9b87&scoped=true&"
import script from "./footer-component.vue?vue&type=script&lang=js&"
export * from "./footer-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c9b87",
  null
  
)

export default component.exports